import { Id } from 'src/types'

interface initialValuesProps {
  active: boolean
  category: string
  comments: string
  id: Id
  max_adults: number
}

export const initialValues = {
  active: true,
  category: '',
  comments: '',
  id: null,
  max_adults: 1
} as initialValuesProps
